module.exports = __webpack_public_path__ + "img/code.ae0893e5.png";